import React from 'react';

import { FiCreditCard } from 'react-icons/fi';
import { BsCurrencyDollar, BsShield } from 'react-icons/bs';
import { MdOutlineDashboard, MdRule,
  MdOutlineTopic, MdOutlineTask, MdCreateNewFolder, MdOutlineFolderOpen,
  MdFrontLoader, MdOutlineEmergency,
  MdOutlineDrafts, MdOutlineSync, MdOutlineAssignment, MdOutlineSwapHoriz } from 'react-icons/md';

export const gridOrderImage = (props) => (
  <div>
    <img
      className="rounded-xl h-20 md:ml-3"
      src={props.ProductImage}
      alt="order-item"
    />
  </div>
);

export const gridOrderStatus = (props) => (
  <button
    type="button"
    style={{ background: props.StatusBg }}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md"
  >
    {props.Status}
  </button>
);

const customerGridImage = (props) => (
  <div className="image flex gap-4">
    <div>
      <p>{props.CustomerName}</p>
      <p>{props.CustomerEmail}</p>
    </div>
  </div>
);

const customerGridStatus = (props) => (
  <div className="flex gap-2 justify-center items-center text-gray-700 capitalize">
    <p style={{ background: props.StatusBg }} className="rounded-full h-3 w-3" />
    <p>{props.Status}</p>
  </div>
);
export const areaPrimaryXAxis = {
  valueType: 'DateTime',
  labelFormat: 'y',
  majorGridLines: { width: 0 },
  intervalType: 'Years',
  edgeLabelPlacement: 'Shift',
  labelStyle: { color: 'gray' },
};

export const areaPrimaryYAxis = {
  labelFormat: '{value}%',
  lineStyle: { width: 0 },
  maximum: 4,
  interval: 1,
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelStyle: { color: 'gray' },

};

export const colorMappingData = [
  [
    { x: 'Jan', y: 6.96 },
    { x: 'Feb', y: 8.9 },
    { x: 'Mar', y: 12 },
    { x: 'Apr', y: 17.5 },
    { x: 'May', y: 22.1 },
    { x: 'June', y: 25 },
    { x: 'July', y: 29.4 },
    { x: 'Aug', y: 29.6 },
    { x: 'Sep', y: 25.8 },
    { x: 'Oct', y: 21.1 },
    { x: 'Nov', y: 15.5 },
    { x: 'Dec', y: 9.9 },
  ],
  ['#FFFF99'],
  ['#FFA500'],
  ['#FF4040'],
];

export const rangeColorMapping = [
  { label: '1°C to 10°C',
    start: '1',
    end: '10',
    colors: colorMappingData[1] },

  { label: '11°C to 20°C',
    start: '11',
    end: '20',
    colors: colorMappingData[2] },

  { label: '21°C to 30°C',
    start: '21',
    end: '30',
    colors: colorMappingData[3] },

];

export const ColorMappingPrimaryXAxis = {
  valueType: 'Category',
  majorGridLines: { width: 0 },
  title: 'Months',
};

export const ColorMappingPrimaryYAxis = {
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
  labelFormat: '{value}°C',
  title: 'Temperature',
};

export const FinancialPrimaryXAxis = {
  valueType: 'DateTime',
  minimum: new Date('2016, 12, 31'),
  maximum: new Date('2017, 9, 30'),
  crosshairTooltip: { enable: true },
  majorGridLines: { width: 0 },
};

export const FinancialPrimaryYAxis = {
  title: 'Price',
  minimum: 100,
  maximum: 180,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
};

export const LinePrimaryXAxis = {
  valueType: 'DateTime',
  labelFormat: 'y',
  intervalType: 'Years',
  edgeLabelPlacement: 'Shift',
  majorGridLines: { width: 0 },
  background: 'white',
};

export const LinePrimaryYAxis = {
  labelFormat: '{value}%',
  rangePadding: 'None',
  minimum: 0,
  maximum: 100,
  interval: 20,
  lineStyle: { width: 0 },
  majorTickLines: { width: 0 },
  minorTickLines: { width: 0 },
};

export const customersGrid = [
  { headerText: 'Cliente',
    width: '150',
    template: customerGridImage,
    textAlign: 'Center' },
  { field: 'ProjectName',
    headerText: 'Teléfono',
    width: '150',
    textAlign: 'Center' },
  { field: 'Status',
    headerText: 'Estado',
    width: '130',
    format: 'yMd',
    textAlign: 'Center',
    template: customerGridStatus },
  {
    field: 'Weeks',
    headerText: 'Cupo',
    width: '100',
    format: 'C2',
    textAlign: 'Center' },
  { field: 'Budget',
    headerText: 'Fiado',
    width: '100',
    format: 'yMd',
    textAlign: 'Center' },

  { field: 'Location',
    headerText: 'Última Compra',
    width: '150',
    textAlign: 'Center' },
  { field: 'CustomerID',
    headerText: 'Rut',
    width: '120',
    textAlign: 'Center',
    isPrimaryKey: true,
  },

];

export const employeesGrid2 = [
  { field: 'EmployeeID',
  headerText: 'Cliente',
  width: '180',
  textAlign: 'Rigth' },
  { field: 'HireDate',
    headerText: 'Fecha',
    width: '120',
    textAlign: 'Left',
  },
  { field: 'Title',
    headerText: 'Deuda',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Name',
  headerText: 'Abonos',
  width: '135',
  textAlign: 'Center' },
  { field: 'ReportsTo',
    headerText: 'Saldos',
    width: '120',
    textAlign: 'Center' }
];

export const employeesGrid = [
  { field: 'EmployeeID',
  headerText: 'Voucher',
  width: '120',
  textAlign: 'Rigth' },
  { field: 'EmployeeID',
  headerText: 'Boleta SII',
  width: '120',
  textAlign: 'Rigth' },
  { field: 'HireDate',
    headerText: 'Fecha - Hora',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Title',
    headerText: 'Monto',
    width: '170',
    textAlign: 'Left',
  },
  { field: 'Name',
  headerText: 'Pago',
  width: '135',
  textAlign: 'Center' },
  { field: 'ReportsTo',
    headerText: 'Vendedor',
    width: '120',
    textAlign: 'Center' }
];


export const links = [{
      links: [
      {
        name: 'dashboard',
        icon: <MdOutlineDashboard />,
      },
    ]},
    {
    title: 'Equipos',
    links: [
      {
        name: 'Solicitudes',
        icon: <MdOutlineTopic />,
      },
      {
        name: 'logística de maquinas',
        icon: <MdOutlineTask />,
      },
      {
        name: 'Autorizaciones',
        icon: <MdRule />,
      },
      {
        name: 'Implementación',
        icon: <MdFrontLoader />,
      },
      {
        name: 'Carpetas',
        icon: <MdCreateNewFolder />,
      },
      {
        name: 'Acreditación',
        icon: <MdOutlineAssignment />,
      },
      {
        name: 'Tickets',
        icon: <MdOutlineDrafts />,
      },
      {
        name: 'Fichas Equipos',
        icon: <MdOutlineFolderOpen />,
      },
      {
        name: 'Salida de Obra',
        icon: <MdOutlineSync />,
      },
      {
        name: 'Traspaso de Equipo',
        icon: <MdOutlineSwapHoriz />,
      },
    ],
  },
    {
    title: 'Reportes',
    links: [
      {
        name: 'bitacora solicitud',
        icon: <MdOutlineDashboard />,
      },
       {
        name: 'bitacora equipo',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Auditoria',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Estatus Equipos',
        icon: <MdOutlineDashboard />,
      },
    ],
  },
  {
    title: 'Configuración',
    links: [
      {
        name: 'maestros',
        icon: <MdOutlineEmergency />,
        children: [
          { name: "equipos", icon: <MdOutlineEmergency /> },
          { name: "proveedores", icon: <MdOutlineEmergency /> },
          { name: "mandantes", icon: <MdOutlineEmergency /> },
          { name: "cargos", icon: <MdOutlineEmergency /> },
          { name: "personas", icon: <MdOutlineEmergency /> },
        ],
      },
      {
        name: 'proyectos',
        icon: <MdOutlineEmergency />,
      },
      {
        name: 'personal bnovus', // La clase "capitalize" lo convertirá en "personal bnovus"
        icon: <MdOutlineAssignment />, // Puedes cambiar este icono
        url: 'https://login.bnovus.cl/Seleccion/PorProyectov2/Proyecto/ListaProyectostarja.aspx',
      },
      {
        name: 'parametros',
        icon: <MdOutlineEmergency />,
        children: [
          { name: "usuarios", icon: <MdOutlineEmergency /> },
          { name: "maquinas", icon: <MdOutlineEmergency /> },
          { name: "documentos mandantes", icon: <MdOutlineEmergency /> },
          { name: "documentos generales", icon: <MdOutlineEmergency /> },
          { name: "gestión de carpetas", icon: <MdOutlineEmergency /> },
        ],
      },
    ],
  },
];

export const linksCalExpTa = [
  {
      links: [
      {
        name: 'notificaciones',
        icon: <MdOutlineDrafts />,
      },
      {
        name: 'dashboard',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'bitacora solicitud',
        icon: <MdOutlineDashboard />,
      },
       {
        name: 'bitacora equipo',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Carpetas',
        icon: <MdCreateNewFolder />,
      },
      {
        name: 'Acreditación',
        icon: <MdOutlineAssignment />,
      },
      {
        name: 'Fichas Equipos',
        icon: <MdOutlineFolderOpen />,
      },
      {
        name: 'Estatus Equipos',
        icon: <MdOutlineDashboard />,
      },
    ]},
];


export const linksJefeTecnica = [
  {
      links: [
      {
        name: 'dashboard',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'bitacora solicitud',
        icon: <MdOutlineDashboard />,
      },
       {
        name: 'bitacora equipo',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Estatus Equipos',
        icon: <MdOutlineDashboard />,
      },
    ]},
  {
    title: 'Equipos',
    links: [
      {
        name: 'Solicitudes',
        icon: <MdOutlineTopic />,
      },
      {
        name: 'Autorizaciones',
        icon: <MdRule />,
      },
      {
        name: 'Carpetas',
        icon: <MdCreateNewFolder />,
      },
      {
        name: 'Acreditación',
        icon: <MdOutlineAssignment />,
      },
      {
        name: 'Fichas Equipos',
        icon: <MdOutlineFolderOpen />,
      },
      {
        name: 'Salida de Obra',
        icon: <MdOutlineSync />,
      },
      {
        name: 'Traspaso de Equipo',
        icon: <MdOutlineSwapHoriz />,
      },
    ],
  },
    {
    title: 'Proyectos',
    links: [
      {
        name: 'personal bnovus', // La clase "capitalize" lo convertirá en "personal bnovus"
        icon: <MdOutlineAssignment />, // Puedes cambiar este icono
        url: 'https://login.bnovus.cl/Seleccion/PorProyectov2/Proyecto/ListaProyectostarja.aspx',
      },
    ],
  }, 
];




export const linksSolicitante = [
  {
      links: [
      {
        name: 'dashboard',
        icon: <MdOutlineDashboard />,
      },
    ]},
  {
    title: 'Equipos',
    links: [
      {
        name: 'Solicitudes',
        icon: <MdOutlineTopic />,
      },
      {
        name: 'Carpetas',
        icon: <MdCreateNewFolder />,
      },
      {
        name: 'Acreditación',
        icon: <MdOutlineAssignment />,
      },
      {
        name: 'Fichas Equipos',
        icon: <MdOutlineFolderOpen />,
      },
      {
        name: 'Salida de Obra',
        icon: <MdOutlineSync />,
      },
      {
        name: 'Traspaso de Equipo',
        icon: <MdOutlineSwapHoriz />,
      },
    ],
  },
    {
    title: 'Reportes',
    links: [
      {
        name: 'bitacora solicitud',
        icon: <MdOutlineDashboard />,
      },
     {
        name: 'bitacora equipo',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Estatus Equipos',
        icon: <MdOutlineDashboard />,
      },
    ],
  },
];

export const linksLogistica = [
  {
      links: [
      {
        name: 'dashboard',
        icon: <MdOutlineDashboard />,
      },
    ]},
  {
    title: 'Equipos',
    links: [
      {
        name: 'Solicitudes',
        icon: <MdOutlineTopic />,
      },
      {
        name: 'logística de maquinas',
        icon: <MdOutlineTask />,
      },
            {
        name: 'Implementación',
        icon: <MdFrontLoader />,
      },
      {
        name: 'Carpetas',
        icon: <MdCreateNewFolder />,
      },
      {
        name: 'Acreditación',
        icon: <MdOutlineAssignment />,
      },
      {
        name: 'Fichas Equipos',
        icon: <MdOutlineFolderOpen />,
      },
    ],
  },
  {
    title: 'Reportes',
    links: [
      {
        name: 'bitacora solicitud',
        icon: <MdOutlineDashboard />,
      },
     {
        name: 'bitacora equipo',
        icon: <MdOutlineDashboard />,
      },
      {
        name: 'Estatus Equipos',
        icon: <MdOutlineDashboard />,
      },
    ],
  },
  {
    title: 'Maestros',
    links: [
      {
        name: 'equipos',
        icon: <MdOutlineEmergency />,
      },
      {
        name: 'proveedores',
        icon: <MdOutlineEmergency />,
      },
    ],
  },
  {
    title: 'Configuración',
    links: [
     { name: "documentos mandantes", icon: <MdOutlineEmergency /> },
      { name: "documentos generales", icon: <MdOutlineEmergency /> },
      {
        name: 'maquinas',
        icon: <MdOutlineEmergency />,
      },
      {
        name: 'proyectos',
        icon: <MdOutlineEmergency />,
      },
    ],
  },
];

export const themeColors = [
  {
    name: 'blue-theme',
    color: '#1A97F5',
  },
  {
    name: 'green-theme',
    color: '#03C9D7',
  },
  {
    name: 'purple-theme',
    color: '#7352FF',
  },
  {
    name: 'red-theme',
    color: '#FF5C8E',
  },
  {
    name: 'indigo-theme',
    color: '#1E4DB7',
  },
  {
    color: '#FB9678',
    name: 'orange-theme',
  },
];

export const userProfileData = [
  {
    icon: <BsCurrencyDollar />,
    title: 'My Profile',
    desc: 'Account Settings',
    iconColor: '#03C9D7',
    iconBg: '#E5FAFB',
  },
  {
    icon: <BsShield />,
    title: 'My Inbox',
    desc: 'Messages & Emails',
    iconColor: 'rgb(0, 194, 146)',
    iconBg: 'rgb(235, 250, 242)',
  },
  {
    icon: <FiCreditCard />,
    title: 'My Tasks',
    desc: 'To-do and Daily Tasks',
    iconColor: 'rgb(255, 244, 229)',
    iconBg: 'rgb(254, 201, 15)',
  },
];


export const contextMenuItems = [
  'AutoFit',
  'AutoFitAll',
  'SortAscending',
  'SortDescending',
  'Copy',
  'Edit',
  'Delete',
  'Save',
  'Cancel',
  'PdfExport',
  'ExcelExport',
  'CsvExport',
  'FirstPage',
  'PrevPage',
  'LastPage',
  'NextPage',
];
